(function ($) {

    function showRemaining() {
        
        var _second = 1000;
        var _minute = _second * 60;
        var _hour = _minute * 60;
        var _day = _hour * 24;
        var end = new Date($('.countdown__clock').data('end-date-time'));

        var now = new Date();
        var distance = end - now;
        // hide the block if expired
        if (distance < 0) {
            $('.countdown__clock').hide();

            return;
        }

        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        var markUp = '<div class="countdown__item"><span class="number">' + days + '</span><span class="text">Days</span></div><div class="colon"><span class="dot"></span><span class="dot"></span></div><div class="countdown__item"><span class="number">' + hours + '</span><span class="text">Hours</span></div><div class="colon"><span class="dot"></span><span class="dot"></span></div><div class="countdown__item"><span class="number">' + minutes + '</span><span class="text">Minutes</span></div><div class="colon"><span class="dot"></span><span class="dot"></span></div><div class="countdown__item"><span class="number">' + seconds + '</span><span class="text">Seconds</span></div>';

        $('.countdown__clock').html(markUp);
    }


    $(document).ready(() => { 
        if( $('.countdown').length) {
            setInterval(showRemaining, 1000);  
        }
    });

})(jQuery);
